export const GET_LICENSED_DEVICES_REQUEST = 'GET_LICENSED_DEVICES_REQUEST' as const;
export const GET_LICENSED_DEVICES_SUCCESS = 'GET_LICENSED_DEVICES_SUCCESS' as const;
export const GET_LICENSED_DEVICES_ERROR = 'GET_LICENSED_DEVICES_ERROR' as const;

export const CLOSE_ERROR_POPUP_LICENSED_DEVICES = 'CLOSE_ERROR_POPUP_LICENSED_DEVICES' as const;
